<div *ngIf="progressBarService.progressBarVisible$ | async" class="progress-bar-container">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>